export default __webpack_public_path__ + "static/ht-9903be3bfac8099fe813b805e5a5f2c3.svg";